import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import { API } from "../../apis/api";
import { buildErrorMessage } from "../../apis/calls";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";

import { RESOURCE_TYPE, API_RESOURCE_URLS } from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";

import { FreePoolAggregate } from "../../components";

const FreePoolAggregateView = ({ aggregate }) => {
  const { showInternalError, showError } = usePopupManager();

  const [plant] = usePlantAndLinesStore().plantState;
  const [aggregateLine] = usePlantAndLinesStore().aggregateLineState;

  const [freePoolCount, setFreePoolCount] = useState(0);

  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });

  const loadFreePoolAggregates = async (plantId, lineId) => {
    if (!plantId) return;
    if (!lineId) return;

    try {
      setRowsData((prev) => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(
        API_RESOURCE_URLS.getFreePoolAggregate(plantId, aggregate),
      );

      const data = (response?.data || []).map((row) => ({
        ...row,
        agsn: row.asn,
        destination: plant.label
      }));

      setRowsData({
        loading: false,
        data,
        filteredData: data,
      });

      setFreePoolCount(data.length);
    } catch (error) {
      console.error(buildErrorMessage(error));

      if (error?.response?.status === 400) {
       showError({
        contextText: `Failed to fetch data`,
        error: error,
      });
      } else {
        showInternalError({
          error,
        });
      }

      setRowsData({
        loading: false,
        data: [],
        filteredData: [],
      });
    }
  };

  const handleReloadData = async () => {
    if (plant?.value && aggregateLine?.value) {
      await loadFreePoolAggregates(plant.value, aggregateLine.value);
    }
  };

  useEffect(() => {
    if (plant?.value && aggregateLine?.value) {
      loadFreePoolAggregates(plant.value, aggregateLine.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant?.value, aggregateLine?.value]);

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Free Pool Aggregates",
            title: "Free Pool Aggregates",
            count: freePoolCount,
            component: FreePoolAggregate,
            props: {
              aggregate,
              rowsData,
              setFreePoolCount,
              loadFreePoolAggregates,
            },
          },
        ]}
        pageTitle="Free Pool Aggregates"
        reloadData={handleReloadData}
      />
    </div>
  );
};

FreePoolAggregateView.propTypes = {
  aggregate: PropTypes.string.isRequired,
};

export default withAllowedOperationsProvider(
  FreePoolAggregateView,
  true,
  RESOURCE_TYPE.MATERIAL,
);
